import * as React from 'react';
import { useTimePilotT } from "@/i18n/useTimePilotT";
import { QuestionIcon, MagnifyingGlassIcon, VideoIcon, EnvelopeIcon, FacebookLogo, InstagramLogo, ChatCircleIcon, SecurityCamera } from "@phosphor-icons/react";

export const evidenceTypeValues = [ undefined, 'body cam', 'cctv', 'email', 'facebook post', 'instagram', 'signal', 'other'];
const evidenceTypeIcons: Record<string, React.ReactNode> = {
  'body cam' : <VideoIcon size={16} />,
  'cctv' : <SecurityCamera size={16} />,
  'email' : <EnvelopeIcon size={16} />,
  'facebook post' : <FacebookLogo size={16} />,
  'instagram' : <InstagramLogo size={16} />,
  'signal' : <ChatCircleIcon size={16} />,
  'other' : <MagnifyingGlassIcon size={16} />,
};

const EvidenceTypes = React.memo((props: { value: string }) => {
  const t = useTimePilotT();
  return (
    <div aria-label={t("viewers.evidenceType")} className="flex justify-left items-center">
      {evidenceTypeIcons[props.value] || <QuestionIcon size={16} />}&nbsp;&nbsp;{props.value}
    </div>
  );
});

EvidenceTypes.displayName = 'EvidenceTypes';

export default EvidenceTypes;
